import { ResourceType } from '@/constants/resources';
import Btn from '@/components/Button/Button.vue';
import PlaceTab from '@/views/Brand/Applications/Components/Resources/PlaceTab.vue';
import ObjectTab from '@/views/Brand/Applications/Components/Resources/ObjectTab.vue';
import { computed, defineComponent, ref, watch, } from '@vue/composition-api';
import ResourcesWrapper from '@/components/ResourcesWrapper/ResourcesWrapper.vue';
import { usePlaceResourcesStore } from '@/store/place-resources';
import { useObjectResourcesStore } from '@/store/object-resources';
import { BTN_THEMES } from '@/store/modules/ui';
import Modal from '@/components/Modal/__new__/Modal.vue';
import { PortalTarget } from '@/constants/portal';
export default defineComponent({
    components: {
        ResourcesWrapper,
        PlaceTab,
        Modal,
        ObjectTab,
        Btn,
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        activeTab: {
            type: String,
            default: ResourceType.PLACES,
        },
        reportId: {
            type: String,
        },
        title: String,
        message: String,
        cancelBtn: Boolean,
        hideHeader: Boolean,
    },
    setup(props, ctx) {
        const componentType = ref('modal');
        const tab = ref(props.activeTab);
        const tabs = computed(() => {
            return Object.values(ResourceType).map((tab) => ({
                name: tab,
                label: ctx.root.$t(`resources.${tab}`),
            }));
        });
        watch(() => props.activeTab, (value) => {
            tab.value = value;
        });
        const { flushPendingPlaces, pendingPlaces, addedPlaces } = usePlaceResourcesStore();
        const { flushPendingObjects, pendingObjects } = useObjectResourcesStore();
        const isButtonDisabled = computed(() => {
            return (pendingPlaces.value.length === 0 && pendingObjects.value.length === 0);
        });
        const addResources = () => {
            flushPendingPlaces();
            flushPendingObjects();
            ctx.emit('submit', addedPlaces.value);
            ctx.emit('input', false);
        };
        const toggleModalDisplay = (value) => {
            ctx.emit('input', value);
        };
        const resourcesModalCssVars = computed(() => {
            const footerHeight = '6rem';
            return {
                '--resources-modal-footer-height': footerHeight,
                '--resources-modal-height': `min(80rem, calc(100vh - 4rem - ${footerHeight}))`,
                '--resources-modal-height-mobile': `calc(100vh - 5rem - ${footerHeight})`,
            };
        });
        return {
            PortalTarget,
            componentType,
            ResourceType,
            isButtonDisabled,
            tab,
            tabs,
            addResources,
            toggleModalDisplay,
            BTN_THEMES,
            resourcesModalCssVars,
        };
    },
});
